<template>
  <div class="grid">
    <div class="border pa-5 d-flex flex-wrap">
      <BaseInput
        type="autocomplete"
        v-model="filter.checked.projects"
        :items="Object.values(filter.projects)"
        item-text="text"
        item-value="id"
        :label="localStorage.translations.pages['planning_orders'].table['proekt']"
        placeholder="—"
        multiple
        minimize
        small-chips
        max-width="500px"
      />
      <BaseInput
        type="autocomplete"
        v-model="filter.checked.employees"
        :items="Object.values(filter.employees)"
        item-text="text"
        item-value="id"
        :label="localStorage.translations.pages.finance['period-table'].employee"
        placeholder="—"
        multiple
        minimize
        small-chips
        max-width="500px"
      />
      <div class="ml-auto mt-5">
        <BaseButton
          :text="localStorage.translations.pages.common.buttons['clear']"
          @click="clearFilter"
          reverse
          height="30"
          :disabled="!filter.compare.projects.length && !filter.compare.employees.length"
        />
        <BaseButton
          :text="localStorage.translations.pages.common.buttons['primenit']"
          @click="updatePeriod"
          height="30"
          class="ml-4"
          :disabled="!changed"
        />
      </div>
    </div>
    <template v-if="Object.keys(projects).length">
      <template v-if="!ganttPage">
        <FinanceSalarySliceShowTable :key="key" class="horizontalScroll">
          <FinanceSalarySliceShowTableHeader :responsible-total-show="false"/>
          <FinanceSalarySliceShowTableTotal
            v-for="(project, p) in projects"
            :key="'total_project_' + p"
            :works="Object.values(project.work_types)"
            :extras="Object.values(project.extras)"
            :project-name="project.name"
            :position-plus="project.positionPlus"
            :responsible-total-show="false"
          />
        </FinanceSalarySliceShowTable>
      </template>
      <template v-if="employeeSalaryPeriod.reports">
        <div>
          <div
            v-for="(employee, e) in employeeSalaryPeriod.reports.all.employees"
            :key="'employee' + e"
            class="horizontalScroll"
          >
            <FinanceSalarySliceShowEmployee
              :data="employee"
              :id="e"
              :period="period"
              :check-edit-access="checkEditAccess"
              :on-update="onUpdate"
              :ref="'employee' + e"
              :collection="employeeSalaryPeriod.reports"
              :responsible-show="responsibleShow"
            />
          </div>
          <FinanceSalarySliceShowTable v-if="responsibleShow" total-responsible class="horizontalScroll">
            <div slot="title" class="pb-5 subtitle">
              {{ localStorage.translations.pages['sales_project']['planned_resources-responsible_employees'].main }}
            </div>
            <FinanceSalarySliceShowTableHeader total-responsible />
            <FinanceSalarySliceShowTableTotal total-responsible
              v-for="(resp, r) in projects"
              :key="r + '_responsible'"
              :responsible="resp"
            />
          </FinanceSalarySliceShowTable>
        </div>
        <div class="fixedBtn">
          <FinanceSalarySliceShowPdf
            :key="key"
            :projects="projects"
            :period="period"
            :employees="employees"
            :disabled="changedData"
            :responsible="projects"
            :responsible-show-total="responsibleShow"
          />
        </div>
      </template>
    </template>
    <template v-else>
      <Plug class="mt-10" />
    </template>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import FinanceSalarySliceShowTable from 'components/finance/salary/show/FinanceSalarySliceShowTable'
import FinanceSalarySliceShowTableHeader from 'components/finance/salary/show/FinanceSalarySliceShowTableHeader'
import FinanceSalarySliceShowTableTotal from 'components/finance/salary/show/FinanceSalarySliceShowTableTotal'
import FinanceSalarySliceShowTableByDays from 'components/finance/salary/show/FinanceSalarySliceShowTableByDays'
import FinanceSalarySliceShowPdf from "components/finance/salary/show/FinanceSalarySliceShowPdf";
import FinanceSalarySliceShowEmployee from "components/finance/salary/FinanceSalarySliceShowEmployee";
import BaseButton from "components/base/BaseButton";
import Plug from "components/Plug";

export default {
  name: 'salarySliceShow',
  components: {
    Plug,
    BaseButton,
    FinanceSalarySliceShowEmployee,
    FinanceSalarySliceShowPdf,
    //FinanceSalarySliceShowTableByDays,
    FinanceSalarySliceShowTableTotal,
    FinanceSalarySliceShowTableHeader,
    FinanceSalarySliceShowTable,
  },
  data: () => ({
    minWidth: 1500,
    maxWidth: 2400,
    key: 0,
    loading: false,
    filter: {
      employees: {},
      projects: {},
      checked: {
        employees: [],
        projects: [],
      },
      compare: {
        employees: [],
        projects: [],
      }
    },
  }),
  computed: {
    ...mapGetters('employeeSalaryPeriod', ['employeeSalaryPeriod']),
    routes() {
      return []
    },
    projects() {
      let result =
        this.employeeSalaryPeriod &&
        this.employeeSalaryPeriod.reports &&
        this.employeeSalaryPeriod.reports.all
          ? this.employeeSalaryPeriod.reports.all.projects || {}
          : {}
      let positionPlus = 0
      for (let i in result) {
        result[i].id = i
        result[i].positionPlus = positionPlus
        result[i].responsible = result[i]?.responsible ? Object.values(result[i].responsible) : []
        result[i].responsibleShow = result[i]?.responsible ? Object.keys(result[i].responsible).length > 0 : false
        positionPlus += Object.keys(result[i]['work_types']).length +
          (Object.keys(result[i]['extras']).length ? 1 : 0)
      }
      return result
    },
    responsibleShow() {
      let result = false
      for (let pr in this.projects) {
        if (this.projects[pr].responsibleShow)
          result = true
      }
      return result
    },
    period() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.key++
      let temp =
        this.employeeSalaryPeriod && this.employeeSalaryPeriod.period
          ? Object.values(this.employeeSalaryPeriod.period)
          : []
      if (!temp.length) return {}
      let s = temp[1].split('/')
      let e = temp[2].split('/')
      return {
        term: temp[1].split('/').join('.') + ' - ' + temp[2].split('/').join('.') + ' ',
        weeks: temp[3],
        start: s[2] + '-' + s[1] + '-' + s[0],
        end: e[2] + '-' + e[1] + '-' + e[0],
      }
    },
    employees() {
      let result = []
      if (this.employeeSalaryPeriod.reports) {
        for (let i in this.employeeSalaryPeriod.reports.all.employees) {
          if (this.$refs['employee' + i] && this.$refs['employee' + i][0]) {
            result.push(this.$refs['employee' + i][0].employee)
          }
        }
      }
      return result
    },
    ganttPage() {
      return this.$route.name.includes('Gantt')
    },
    pageName() {
      return this.$route.name.includes('Gantt')
        ? this.$route.name.replace('Gantt', '')
        : this.$route.name
    },
    checkEditAccess() {
      return this.$userCheckAccess({
        abilities: 'edit_salary',
      })
    },
    changedData() {
      let result = [false]
      if (this.employeeSalaryPeriod && this.employeeSalaryPeriod.reports.all.employees)
        for (let e in this.employeeSalaryPeriod.reports.all.employees)
          if (this.$refs['employee' + e] && this.$refs['employee' + e][0]) {
            let temp = this.$refs['employee' + e][0].changedData
            result = result.concat(Object.values(temp).map(d => d.changedData))
          }
      return !result.every(e => { return !e })
    },
    changed() {
      if (this.filter.compare.employees.length !== this.filter.checked.employees.length)
        return true
      if (this.filter.compare.projects.length !== this.filter.checked.projects.length)
        return true
      for (let i in this.filter.compare.employees)
        if (!this.filter.compare.employees.includes(this.filter.checked.employees[i]))
          return true
      for (let i in this.filter.compare.projects)
        if (!this.filter.compare.projects.includes(this.filter.checked.projects[i]))
          return true
      return false
    },
  },
  created() {
    this.updatePeriod()
  },
  methods: {
    ...mapActions('employeeSalaryPeriod', ['onEmployeeSalaryPeriod']),
    ...mapActions('workClientProjectsPeriodReportUpdate', [
      'onWorkClientProjectsPeriodReportUpdate',
    ]),

    async updatePeriod() {
      await this.onEmployeeSalaryPeriod({
        id: this.$route.params.period_id,
        user: this.filter.checked.employees,
        project: this.filter.checked.projects,
      }).then(() => {
        if (this.employeeSalaryPeriod.reports) {
          this.filter.compare.employees = Object.assign([], this.filter.checked.employees)
          this.filter.compare.projects = Object.assign([], this.filter.checked.projects)
          for (let i in this.employeeSalaryPeriod.reports.all.employees)
            if (!this.filter.employees[i])
              this.filter.employees[i] = {
                id: i,
                text:
                  this.employeeSalaryPeriod.reports.all.employees[i]['first_name'] +
                  ' ' + this.employeeSalaryPeriod.reports.all.employees[i]['last_name'],
              }
          for (let i in this.employeeSalaryPeriod.reports.all.projects)
            if (!this.filter.projects[i])
              this.filter.projects[i] = {
                id: i,
                text: this.employeeSalaryPeriod.reports.all.projects[i].name,
              }
        }
        this.key++
      })
    },

    clearFilter() {
      this.filter.checked.projects = []
      this.filter.checked.employees = []
      this.updatePeriod()
    },

    async onUpdate(data, switchValue, extra, responsible) {
      if (data && data.length > 0) {
        this.loadingAnimationFullPage = true
        await this.onWorkClientProjectsPeriodReportUpdate({
          id: this.$route.params.report_id,
          data: responsible ? data.map(i => i.id) : data,
          paid: true,
          responsible: responsible,
          extra: extra,
        }).then(() => {
          this.updatePeriod()
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.flex-wrap {
  column-gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    column-gap: 12px;
  }
}

.grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-row-gap: 30px;
}

.horizontalScroll {
  @media #{map-get($display-breakpoints, 'lg-and-down')} {
    overflow-x: scroll;
    max-width: 93vw;
  }
}

:deep() .subtitle {
  color: #277faf;
  font-weight: bolder;
}

.border {
  border: 1px solid #bdbdbd;
  border-radius: 10px;
}
</style>
